import { FC } from 'react';
import Zendesk, { ZendeskAPI } from 'react-zendesk';

const ZENDESK_KEY = 'c696e340-67c3-49ea-b758-f64af48734a5';

const zendeskSettings = {
    webWidget: {
        position: { horizontal: 'right', vertical: 'top' },
        offset: {
            horizontal: '40px',
            vertical: '45px',
        },
        launcher: {
            label: {
                'en-US': 'Need help?',
                // eslint-disable-next-line quotes
                fr: "Besoin d'aide?",
                '*': 'Need help?',
            },
        },
        contactForm: {
            attachments: false,
        },
    },
};

const ZendeskWrapper: FC = () => {
    ZendeskAPI('webWidget:on', 'close', () => ZendeskAPI('webWidget', 'hide'));

    return (
        <div data-testid="ZendeskWrapper">
            <Zendesk
                defer
                zendeskKey={ZENDESK_KEY}
                {...zendeskSettings}
                onLoaded={() => ZendeskAPI('webWidget', 'hide')}
            />
        </div>
    );
};

export default ZendeskWrapper;
